var _slicedToArray = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var toDateObject = require('./wikibase_time_to_date_object');

var helpers = {};

helpers.isNumericId = function (id) {
  return /^[1-9][0-9]*$/.test(id);
};

helpers.isEntityId = function (id) {
  return /^((Q|P|L)[1-9][0-9]*|L[1-9][0-9]*-(F|S)[1-9][0-9]*)$/.test(id);
};

helpers.isItemId = function (id) {
  return /^Q[1-9][0-9]*$/.test(id);
};

helpers.isPropertyId = function (id) {
  return /^P[1-9][0-9]*$/.test(id);
};

helpers.isLexemeId = function (id) {
  return /^L[1-9][0-9]*$/.test(id);
};

helpers.isFormId = function (id) {
  return /^L[1-9][0-9]*-F[1-9][0-9]*$/.test(id);
};

helpers.isSenseId = function (id) {
  return /^L[1-9][0-9]*-S[1-9][0-9]*$/.test(id);
};

helpers.isGuid = function (guid) {
  return /^((Q|P|L)[1-9][0-9]*|L[1-9][0-9]*-(F|S)[1-9][0-9]*)\$[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(guid);
};

helpers.isHash = function (hash) {
  return /^[0-9a-f]{40}$/.test(hash);
};

helpers.isPropertyClaimsId = function (id) {
  var _id$split = id.split('#'),
      _id$split2 = _slicedToArray(_id$split, 2),
      entityId = _id$split2[0],
      propertyId = _id$split2[1];

  return helpers.isEntityId(entityId) && helpers.isPropertyId(propertyId);
};

helpers.isRevisionId = function (id) {
  return /^\d+$/.test(id);
};

helpers.isEntityPageTitle = function (title) {
  if (typeof title !== 'string') return false;

  var _title$split = title.split(':'),
      _title$split2 = _slicedToArray(_title$split, 2),
      namespace = _title$split2[0],
      id = _title$split2[1];

  if (namespace && id) {
    return isEntityNamespace(namespace) && helpers["is".concat(namespace, "Id")](id);
  } else {
    id = namespace;
    return helpers.isItemId(id);
  }
};

var entityNamespaces = ['Item', 'Property', 'Lexeme'];

var isEntityNamespace = function isEntityNamespace(str) {
  return entityNamespaces.includes(str);
};

var isNonNestedEntityId = function isNonNestedEntityId(id) {
  return /^(Q|P|L)[1-9][0-9]*$/.test(id);
};

helpers.getNumericId = function (id) {
  if (!isNonNestedEntityId(id)) throw new Error("invalid entity id: ".concat(id));
  return id.replace(/^(Q|P|L)/, '');
};

helpers.wikibaseTimeToDateObject = toDateObject; // Try to parse the date or return the input

var bestEffort = function bestEffort(fn) {
  return function (value) {
    try {
      return fn(value);
    } catch (err) {
      value = value.time || value;
      var sign = value[0];

      var _value$slice$split = value.slice(1).split('T'),
          _value$slice$split2 = _slicedToArray(_value$slice$split, 2),
          yearMonthDay = _value$slice$split2[0],
          withinDay = _value$slice$split2[1];

      yearMonthDay = yearMonthDay.replace(/-00/g, '-01');
      return "".concat(sign).concat(yearMonthDay, "T").concat(withinDay);
    }
  };
};

var toEpochTime = function toEpochTime(wikibaseTime) {
  return toDateObject(wikibaseTime).getTime();
};

var toISOString = function toISOString(wikibaseTime) {
  return toDateObject(wikibaseTime).toISOString();
}; // A date format that knows just three precisions:
// 'yyyy', 'yyyy-mm', and 'yyyy-mm-dd' (including negative and non-4 digit years)
// Should be able to handle the old and the new Wikidata time:
// - in the old one, units below the precision where set to 00
// - in the new one, those months and days are set to 01 in those cases,
//   so when we can access the full claim object, we check the precision
//   to recover the old format


var toSimpleDay = function toSimpleDay(wikibaseTime) {
  // Also accept claim datavalue.value objects, and actually prefer those,
  // as we can check the precision
  if (typeof wikibaseTime === 'object') {
    var _wikibaseTime = wikibaseTime,
        time = _wikibaseTime.time,
        precision = _wikibaseTime.precision; // Year precision

    if (precision === 9) wikibaseTime = time.replace('-01-01T', '-00-00T'); // Month precision
    else if (precision === 10) wikibaseTime = time.replace('-01T', '-00T');else wikibaseTime = time;
  }

  return wikibaseTime.split('T')[0] // Remove positive years sign
  .replace(/^\+/, '') // Remove years padding zeros
  .replace(/^(-?)0+/, '$1') // Remove days if not included in the Wikidata date precision
  .replace(/-00$/, '') // Remove months if not included in the Wikidata date precision
  .replace(/-00$/, '');
};

helpers.wikibaseTimeToEpochTime = bestEffort(toEpochTime);
helpers.wikibaseTimeToISOString = bestEffort(toISOString);
helpers.wikibaseTimeToSimpleDay = bestEffort(toSimpleDay);

helpers.getImageUrl = function (filename, width) {
  var url = "https://commons.wikimedia.org/wiki/Special:FilePath/".concat(filename);
  if (typeof width === 'number') url += "?width=".concat(width);
  return url;
};

helpers.getEntityIdFromGuid = function (guid) {
  return guid.split('$')[0].toUpperCase();
};

module.exports = helpers;